<h3 class="title configurator-title">{{ 'closet-doors-custom.finishes.title' | translate }}</h3>

<!-- STRUCTURES -->
<div class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    <span>{{ 'closet-doors-custom.finishes.door-structure' | translate }}</span>
  </h4>
  <span class="disabled-product pt-1 ml-4" *ngIf="!configuration.hasValidQuotation && !isDoorStructureValid()">
    {{ 'closet-doors-custom.finishes.disable-message' | translate }}
  </span>
  <span
    class="disabled-with-quotation-product pt-1 ml-4"
    *ngIf="configuration.hasValidQuotation && !isDoorStructureValid()">
    {{ 'closet-doors-custom.finishes.valid-quotation-message' | translate }}
  </span>
  <div class="collapse-block" *ngIf="subStep === 1">
    <div class="loader-container" *ngIf="doorStructures === undefined">
      <ng-casto-loader></ng-casto-loader>
    </div>
    <div class="door-structure-container">
      <ng-container *ngFor="let door of doorStructures">
        <div
          class="door-structure-card"
          [ngClass]="{ active: isDoorStructureSelected(door.id), disabled: !isStructureCompatible(door) }"
          (click)="selectDoorStructure(door)"
          [title]="
            !isStructureCompatible(door) ? ('closet-doors-custom.finishes.door-structure-incompatible' | translate) : ''
          ">
          <ng-casto-img-loader
            *ngIf="door?.id !== 0"
            [imgSrc]="baseImgURL + door.icon.path"
            [imgClass]="'door-img'"></ng-casto-img-loader>
          <p class="door-structure-title">{{ door.name }}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<br />

<!-- DECORS -->
<div class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 2 }"
    (click)="toggleCollapse(2)">
    <span>{{ 'closet-doors-custom.finishes.decors' | translate }}</span>
  </h4>
  <span class="disabled-product pt-1 ml-4" *ngIf="!configuration.hasValidQuotation && !isDecorValid()">
    {{ 'closet-doors-custom.finishes.disable-message' | translate }}
  </span>
  <span class="disabled-with-quotation-product pt-1 ml-4" *ngIf="configuration.hasValidQuotation && !isDecorValid()">
    {{ 'closet-doors-custom.finishes.valid-quotation-message' | translate }}
  </span>
  <div class="collapse-block" *ngIf="subStep === 2">
    <div class="loader-container" *ngIf="doorStructures === undefined">
      <ng-casto-loader></ng-casto-loader>
    </div>
    <div class="colors-container">
      <!-- Pas de catégorie -->
      <h5 class="colors-title" *ngIf="getColorCategoryToDisplay().length === 0">
        {{ 'closet-doors-custom.finishes.no-selected-door' | translate }}
      </h5>

      <!-- Affichage des catégories -->
      <div
        class="colors-card"
        [ngClass]="{ active: isColorCategorySelected(category.id), disabled: category.isDisabled }"
        *ngFor="let category of getColorCategoryToDisplay()"
        (click)="selectColorCategory(category)">
        <ng-casto-img-loader
          *ngIf="category?.id !== 0"
          [imgSrc]="baseImgURL + category.colors[0]?.icon?.path"
          [imgClass]="'color-img'"></ng-casto-img-loader>
        <p class="color-title">{{ category.name }}</p>
      </div>
    </div>
    <div *ngIf="selectedColorCategory && getColorCategoryToDisplay().length > 0">
      <h5 class="colors-title">
        {{ selectedColorCategory.colors.length }}
        {{ 'closet-doors-custom.finishes.color-choices' | translate }}
      </h5>
      <div class="colors-container">
        <ng-container *ngFor="let color of this.colorsToDisplay">
          <div
            class="colors-card"
            [ngClass]="{ active: isColorSelected(color.id), disabled: color.isDisabled }"
            (click)="selectColor(color)">
            <ng-casto-img-loader [imgSrc]="baseImgURL + color.icon.path" [imgClass]="'color-img'"></ng-casto-img-loader>
            <p class="color-title">{{ color.name }}</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<br />

<!-- PROFILES -->
<div class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 3 }"
    (click)="toggleCollapse(3)">
    <span>{{ 'closet-doors-custom.finishes.frames' | translate }}</span>
  </h4>
  <span class="disabled-product pt-1 ml-4" *ngIf="!configuration.hasValidQuotation && !isFrameFinishValid()">
    {{ 'closet-doors-custom.finishes.disable-message' | translate }}
  </span>
  <span
    class="disabled-with-quotation-product pt-1 ml-4"
    *ngIf="configuration.hasValidQuotation && !isFrameFinishValid()">
    {{ 'closet-doors-custom.finishes.valid-quotation-message' | translate }}
  </span>
  <div class="collapse-block" *ngIf="subStep === 3">
    <div class="loader-container" *ngIf="frameTypesToDisplay.length === 0">
      <ng-casto-loader></ng-casto-loader>
    </div>

    <!-- Cards frame types -->
    <div class="colors-container" *ngIf="frameTypesToDisplay.length > 0">
      <div
        class="colors-card"
        [ngClass]="{ active: isFrameTypeSelected(frameType.id) }"
        *ngFor="let frameType of frameTypesToDisplay"
        (click)="selectFrameType(frameType)">
        <img [src]="baseImgURL + frameType.icon" [ngClass]="'color-img'" />
        <p class="color-title">{{ frameType.name }}</p>
      </div>
    </div>

    <ng-container *ngIf="framesToDisplay.length > 0">
      <!-- Frames count -->
      <h5 class="colors-title">
        {{ framesToDisplay.length }} {{ 'closet-doors-custom.finishes.frames-choices' | translate }}
      </h5>

      <!-- Cards frames -->
      <div class="frame-structure-container" *ngIf="selectedFrameType">
        <div
          class="frame-structure-card"
          [ngClass]="{ active: isFrameSelected(frame.id), disabled: frame.isDisabled }"
          *ngFor="let frame of framesToDisplay"
          (click)="selectFrame(frame)">
          <ng-casto-img-loader
            *ngIf="frame?.id !== 0"
            [imgSrc]="baseImgURL + frame.icon.path"
            [imgClass]="'color-img'"></ng-casto-img-loader>
          <p class="frame-structure-title">{{ frame.name }}</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="displayFrameFinishes()">
      <!-- Frame finishes count -->
      <h5 class="colors-title">
        {{ frameFinishesToDisplay.length }} {{ 'closet-doors-custom.finishes.frame-finishes-choices' | translate }}
      </h5>

      <!-- Cards frame finishes -->
      <div class="colors-container">
        <div
          class="colors-card"
          [ngClass]="{ active: isFrameFinishSelected(frameFinish.id), disabled: frameFinish.isDisabled }"
          *ngFor="let frameFinish of frameFinishesToDisplay"
          (click)="selectFrameFinish(frameFinish)">
          <ng-casto-img-loader
            [imgSrc]="baseImgURL + frameFinish.icon.path"
            [imgClass]="'color-img'"></ng-casto-img-loader>
          <p class="color-title">{{ frameFinish.name }}</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<br />
